// mockData.js
export const mockOrderData = [
    {
        orderId: "ORD001",
        orderName: "График обмена заданиями 24-24-12",
        orderNumber: "ORD-2025-001",
        status: 1,
        description: "Проектирование и обмен заданиями между отделами",
        operations: [
            {
                operationId: "OP001",
                operationNumber: "OP-001",
                name: "Сводный план сетей_выдача ГПЛ",
                status: 1,
                startDate: "2025-11-05 08:00",
                endDate: "2025-11-05 17:00",
                description: "Выдача сводного плана сетей в отделы",
                resources: [
                    {
                        agentId: "RES001",
                        name: "Иванов Иван",
                        status: 1,
                        type: "Человек",
                        description: "Главный инженер проекта"
                    },
                    {
                        agentId: "MACH001",
                        name: "Рабочая станция ГИП",
                        status: 1,
                        type: "Оборудование",
                        description: "Компьютерная система проектирования"
                    }
                ]
            },
            {
                operationId: "OP002",
                operationNumber: "OP-002",
                name: "Заземление_выдача КиА в ЭЛТ",
                status: 3,
                startDate: "2025-11-06 08:00",
                endDate: "2025-11-17 17:00",
                description: "Передача данных по заземлению между отделами",
                resources: [
                    {
                        agentId: "RES002",
                        name: "Петров Петр",
                        status: 1,
                        type: "Человек",
                        description: "Инженер КИПиА"
                    },
                    {
                        agentId: "MACH002",
                        name: "Система проектирования КИП",
                        status: 1,
                        type: "Оборудование",
                        description: "Специализированное ПО для КИПиА"
                    }
                ]
            },
            {
                operationId: "OP003",
                operationNumber: "OP-003",
                name: "Заземление трубопроводов_выдача ЭЛТ",
                status: 6,
                startDate: "2025-11-05 09:00",
                endDate: "2025-11-10 16:00",
                description: "Выдача документации по заземлению трубопроводов",
                resources: [
                    {
                        agentId: "RES003",
                        name: "Сидоров Алексей",
                        status: 6,
                        type: "Человек",
                        description: "Инженер-электротехник"
                    },
                    {
                        agentId: "MACH003",
                        name: "Электротехническая станция",
                        status: 6,
                        type: "Оборудование",
                        description: "Рабочее место электротехника"
                    }
                ]
            }
        ]
    },
    {
        orderId: "ORD002",
        orderName: "Теплоизоляция и монтажные чертежи",
        orderNumber: "ORD-2025-002",
        status: 6,
        description: "Работы по теплоизоляции и подготовке монтажных чертежей",
        operations: [
            {
                operationId: "OP004",
                operationNumber: "OP-004",
                name: "Теплоизоляция труб_выдача",
                status: 1,
                startDate: "2025-11-11 09:00",
                endDate: "2025-11-18 16:00",
                description: "Подготовка и выдача документации по теплоизоляции",
                resources: [
                    {
                        agentId: "RES004",
                        name: "Козлова Мария",
                        status: 1,
                        type: "Человек",
                        description: "Инженер теплоснабжения"
                    },
                    {
                        agentId: "MACH004",
                        name: "Теплотехнический комплекс",
                        status: 1,
                        type: "Оборудование",
                        description: "Система проектирования тепловых сетей"
                    }
                ]
            },
            {
                operationId: "OP005",
                operationNumber: "OP-005",
                name: "Монтажные чертежи_выдача",
                status: 6,
                startDate: "2025-11-19 08:00",
                endDate: "2025-11-21 17:00",
                description: "Подготовка монтажных чертежей",
                resources: [
                    {
                        agentId: "RES005",
                        name: "Николаев Дмитрий",
                        status: 6,
                        type: "Человек",
                        description: "Инженер-проектировщик"
                    },
                    {
                        agentId: "MACH005",
                        name: "CAD-станция",
                        status: 6,
                        type: "Оборудование",
                        description: "Система автоматизированного проектирования"
                    }
                ]
            },
            {
                operationId: "OP006",
                operationNumber: "OP-006",
                name: "Ведомость основных комплектующих",
                status: 3,
                startDate: "2025-11-22 10:00",
                endDate: "2025-11-22 17:00",
                description: "Формирование ведомости комплектующих",
                resources: [
                    {
                        agentId: "RES006",
                        name: "Федорова Ольга",
                        status: 3,
                        type: "Человек",
                        description: "Специалист по материалам"
                    }
                ]
            }
        ]
    },
    {
        orderId: "ORD003",
        orderName: "Спецификации и готовые разделы",
        orderNumber: "ORD-2025-003",
        status: 3,
        description: "Подготовка спецификаций и завершающих разделов проекта",
        operations: [
            {
                operationId: "OP007",
                operationNumber: "OP-007",
                name: "ОР спецификации_выдача",
                status: 3,
                startDate: "2025-11-22 07:00",
                endDate: "2025-11-22 14:00",
                description: "Выдача основных рабочих спецификаций",
                resources: [
                    {
                        agentId: "RES007",
                        name: "Васильев Сергей",
                        status: 3,
                        type: "Человек",
                        description: "Инженер-сметчик"
                    },
                    {
                        agentId: "MACH006",
                        name: "Сметная станция",
                        status: 3,
                        type: "Оборудование",
                        description: "Система расчета сметной документации"
                    }
                ]
            },
            {
                operationId: "OP008",
                operationNumber: "OP-008",
                name: "Готовые разделы ГИПу",
                status: 1,
                startDate: "2025-11-23 08:00",
                endDate: "2025-11-23 17:00",
                description: "Передача готовых разделов главному инженеру проекта",
                resources: [
                    {
                        agentId: "RES008",
                        name: "Егорова Анна",
                        status: 1,
                        type: "Человек",
                        description: "Архитектор-проектировщик"
                    },
                    {
                        agentId: "MACH007",
                        name: "Архитектурная станция",
                        status: 1,
                        type: "Оборудование",
                        description: "Система 3D-моделирования"
                    }
                ]
            },
            {
                operationId: "OP009",
                operationNumber: "OP-009",
                name: "Готовые разделы ГИПу (Сметы)",
                status: 6,
                startDate: "2025-11-24 09:00",
                endDate: "2025-11-15 16:00",
                description: "Подготовка сметной документации",
                resources: [
                    {
                        agentId: "RES009",
                        name: "Михайлов Павел",
                        status: 6,
                        type: "Человек",
                        description: "Экономист-сметчик"
                    },
                    {
                        agentId: "MACH008",
                        name: "Финансовый модуль",
                        status: 6,
                        type: "Оборудование",
                        description: "Система финансовых расчетов"
                    }
                ]
            }
        ]
    },
    {
        orderId: "ORD004",
        orderName: "Архивация проекта",
        orderNumber: "ORD-2026-004",
        status: 7,
        description: "Финальная архивация всех разделов проекта",
        operations: [
            {
                operationId: "OP010",
                operationNumber: "OP-010",
                name: "Архив проекта",
                status: 7,
                startDate: "2026-01-03 08:00",
                endDate: "2026-01-03 12:00",
                description: "Формирование архива проекта",
                resources: [
                    {
                        agentId: "RES010",
                        name: "Захарова Екатерина",
                        status: 7,
                        type: "Человек",
                        description: "Архивариус"
                    }
                ]
            },
            {
                operationId: "OP011",
                operationNumber: "OP-011",
                name: "Архив Тепл",
                status: 5,
                startDate: "2026-01-03 13:00",
                endDate: "2026-01-03 17:00",
                description: "Архивация теплового раздела",
                resources: [
                    {
                        agentId: "RES011",
                        name: "Кузнецов Роман",
                        status: 5,
                        type: "Человек",
                        description: "Инженер теплоснабжения"
                    },
                    {
                        agentId: "MACH009",
                        name: "Система архивации",
                        status: 5,
                        type: "Оборудование",
                        description: "Цифровая архивная система"
                    }
                ]
            },
            {
                operationId: "OP012",
                operationNumber: "OP-012",
                name: "Архив ЭЛТ",
                status: 2,
                startDate: "2026-01-04 09:00",
                endDate: "2026-01-04 16:00",
                description: "Архивация электротехнического раздела",
                resources: [
                    {
                        agentId: "RES012",
                        name: "Смирнова Ирина",
                        status: 2,
                        type: "Человек",
                        description: "Инженер-электротехник"
                    }
                ]
            },
            {
                operationId: "OP013",
                operationNumber: "OP-013",
                name: "Архив СМТ",
                status: 1,
                startDate: "2026-01-05 10:00",
                endDate: "2026-01-05 15:00",
                description: "Архивация сметного раздела",
                resources: [
                    {
                        agentId: "RES013",
                        name: "Белов Андрей",
                        status: 1,
                        type: "Человек",
                        description: "Сметчик"
                    }
                ]
            }
        ]
    }
];